(() => {
  if (window.__leventAdsContactTracking) return;
  window.__leventAdsContactTracking = true;
  const tagId = 'AW-18482011506';
  const labels = { phone: '3mwACMmZlKQdEPK69OxE', whatsapp: 'dGTlCMyZlKQdEPK69OxE' };
  let configured = false;
  const sent = new Set();
  function allowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
  }
  function configure() {
    if (!allowed()) return false;
    if (configured) return true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
    }
    window.gtag('config', tagId, { send_page_view: false, allow_ad_personalization_signals: false });
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
      document.head.appendChild(script);
    }
    configured = true;
    return true;
  }
  function kindFor(link) {
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return null; }
    if (url.protocol === 'tel:' && url.pathname.replace(/\D/g, '') === '994505909104') return 'phone';
    if (url.hostname === 'wa.me' && url.pathname.replace(/\D/g, '') === '994505909104') return 'whatsapp';
    if (url.hostname === 'api.whatsapp.com' && (url.searchParams.get('phone') || '').replace(/\D/g, '') === '994505909104') return 'whatsapp';
    return null;
  }
  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.defaultPrevented || event.button !== 0) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    const kind = kindFor(link);
    if (!kind || sent.has(kind) || !configure()) return;
    const key = 'levent-ads-contact-18482011506-' + kind;
    try { if (window.sessionStorage.getItem(key)) return; } catch (_) {}
    let navigate;
    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self')) {
      event.preventDefault();
      let done = false;
      navigate = () => { if (!done) { done = true; window.location.assign(link.href); } };
      window.setTimeout(navigate, 800);
    }
    sent.add(kind);
    try { window.sessionStorage.setItem(key, '1'); } catch (_) {}
    window.gtag('event', 'conversion', {
      send_to: tagId + '/' + labels[kind],
      transport_type: 'beacon',
      event_callback: navigate,
      event_timeout: 700
    });
  });
  document.addEventListener('visitorConsentCollected', configure);
  function start() {
    if (window.Shopify && window.Shopify.customerPrivacy) { configure(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        if (!error) configure();
      });
    }
  }
  start();
})();